import { render } from "./FixPanelHeaderTitle.vue?vue&type=template&id=2e694f6c"
const script = {}

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__